import { render, staticRenderFns } from "./RewardDetail.vue?vue&type=template&id=c19501d8&scoped=true"
import script from "./RewardDetail.vue?vue&type=script&lang=js"
export * from "./RewardDetail.vue?vue&type=script&lang=js"
import style0 from "./RewardDetail.vue?vue&type=style&index=0&id=c19501d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19501d8",
  null
  
)

export default component.exports